




import { Component, Vue } from "vue-property-decorator";
import { GridColumnTypes, GridColumn } from "@/models/grids/column";
import { ActivityAreaDto } from "@/server/app.dtos";
import { Getter } from "vuex-class";

@Component
export default class ActivityStatusPage extends Vue {
  @Getter activityAreas!: ActivityAreaDto[];
  columns: GridColumn[] = [
    {
      text: "Título",
      value: "title",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    },
    {
      text: "Área",
      value: "idActivityArea",
      type: GridColumnTypes.Dropdown,
      editable: true,
      filterable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.required],
      arg: {
        items: [],
        itemText: "title",
        itemValue: "idActivityArea",
        value: null
      }
    },
    {
      value: "isFinal",
      text: "Estado Final",
      editable: true,
      type: GridColumnTypes.Boolean
    },
    {
      value: "isSuccess",
      text: "Estado de Sucesso",
      editable: true,
      type: GridColumnTypes.Boolean
    },
    {
      value: "color",
      text: "Cor",
      editable: true,
      type: GridColumnTypes.Color
    }
  ];
  endpoint: string = "api/activitystatus";
  primary: string = "idActivityStatus";

  created() {
    this.columns[1].arg.items = this.activityAreas;
    this.columns[1].arg.value = this.activityAreas[0];
  }
}
